import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { UserManagementService } from 'app/core/services/user-management.service';
import { AuthService } from 'app/services/auth.service';
import { first } from 'rxjs/operators';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { UserRole } from '../manage-users/manage-users.component';

@Component({
  selector: 'manage-user-dialog',
  templateUrl: './manage-user-dialog.component.html',
  styleUrls: ['./manage-user-dialog.component.scss'],
  encapsulation : ViewEncapsulation.None,
})
export class ManageUserDialogComponent implements OnInit {
  url: any;
  allRoles: Array<UserRole> = [];
  selectedRoles: Array<UserRole> = [];
  dialogTitle = 'Add User';
  firstName: string;
  lastName: string;
  rank: string;
  email: string;
  profilePicture: any;
  profilePictureRequest;
  invalidPicture = false;
  email_domain_approved = false;
  adminApproved = false;
  emailVerified = false;

  @ViewChild('newImage', { static: true }) newImageInput;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManageUserDialogComponent>,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private userManagementService: UserManagementService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.fetchUserRoles();
    if (this.data && this.data.uuid) {
      this.dialogTitle = 'Edit User';
      this.firstName = this.data.firstname;
      this.lastName = this.data.lastname;
      this.rank = this.data.rank;
      this.email = '' + this.data.email;
      this.profilePicture = this.data.profilePicture;
      this.selectedRoles = this.data.roles;
      this.userManagementService.getUserImage(this.data.uuid).pipe(first()).subscribe(url => {
        this.url = url;
      });
      this.email_domain_approved = this.data.email_domain_approved;
      this.emailVerified = this.data.confirmed;
    }
  }

  fetchUserRoles() {
    this.userManagementService.getAllUserRoles().subscribe((results: any) => {
      this.allRoles = results.roles;

      // Set default role if not selected
      if (!this.data || !this.data.uuid) {
        this.selectedRoles = [this.allRoles.find(r => r.name === 'Basic User')];
      }
    });
  }

  compareRolesFn(role1: UserRole, role2: UserRole) {
    return role1 && role2 ? role1.uuid === role2.uuid : role1 === role2;
  }

  save() {
    const result = this.data || {};
    result.firstname = this.firstName;
    result.lastname = this.lastName;
    result.rank = this.rank || '';
    result.email = (this.data && this.data.email === this.email) ? undefined : this.email.trim();
    result.email_domain_approved = this.email_domain_approved;

    if (this.profilePictureRequest) {
      result['profilePicture'] = {
        requestData: this.profilePictureRequest,
        imageDataUrl: this.profilePicture
      };
    }

    result['newRoles'] = this.selectedRoles;

    this.dialogRef.close(result);
  }

  onFileChange(event) {
    if (event && event[0]) {
      if (event[0].type !== 'image/jpg' &&
        event[0].type !== 'image/png' &&
        event[0].type !== 'image/jpeg') {
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Invalid Format',
            content: 'The image must be of file type .jpg, .jpeg, or .png.'
          }
        });
      } else {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.profilePicture = this.sanitizer.bypassSecurityTrustUrl(e.result);
        };

        reader.readAsDataURL(event[0]);
        reader.onload = (e) => {
          this.url = e.target.result;
        };

        this.profilePictureRequest = event[0];
      }
    }
  }

  onApproveEmail() {
    if (this.email_domain_approved) {
      this.authService.approveUserEmail(this.data.uuid).pipe(first()).subscribe(() => {
        this.adminApproved = true;
      }, error => {
        this.email_domain_approved = false;
      });
    } else {
      this.authService.unapproveUserEmail(this.data.uuid).pipe(first()).subscribe(() => {
        this.adminApproved = false;
      }, error => {
        this.email_domain_approved = true;
      });
    }
  }

  resendVerification(): void {
    if (this.data && this.data.email) {
      this.authService.resendVerificationEmail('' + this.data.email).pipe(first()).subscribe((res) => {
        console.log(res);
      }, error => {
        console.error(error);
      });
    }
  }

  resendPasswordChange(): void {
    if (this.data && this.data.email) {
      this.authService.sendResetPasswordEmail('' + this.data.email).pipe(first()).subscribe((res) => {
        console.log(res);
      }, error => {
        console.error(error);
      });
    }
  }
}
